import ROLES from '@/utils/roles';
import FOOTERS from '@/utils/footers';
import TOP_BARS from '@topBars';
let routes = [
  /**
   * @description 老师端管理
   * @function /teacher
   * @param {Component} Info views/school/
   * @param {Name} pathname /school-student
   */
  {
    path: '/teacher',
    name: 'teacher',
    meta: {
      title: 'Teaching System'
    },
    redirect: { name: 'dashboard' }
  },
  {
    path: '/teacher/training-courses/:id',
    name: 'teacher-training-courses-id',
    component: () => import('@/views/teacher/Training/CourseDetail')
  },
  {
    path: '/teacher/brain-olympics',
    name: 'teacher-brain-olympics',
    component: () => import('@/views/student/Manager/Olympics/Teacher')
  },
  {
    path: '/teacher/mission-x',
    name: 'teacher-mission-x',
    meta: {
      title: 'mission-x'
    },
    component: () => import('../../views/student/Manager/Events/MissionX/Teacher')
  },
  {
    path: '/teacher/talent-show',
    name: 'teacher-talent-show',
    meta: {
      title: 'Talent Show'
    },
    component: () => import('../../views/student/Manager/Events/TalentShow/Teacher')
  },
  {
    path: '/teacher/talent-show/rules',
    name: 'teacher-talent-show/rules',
    meta: {
      title: 'Talent Show'
    },
    component: () => import('../../views/student/TalentShow/Teacher')
  },
  {
    path: '/teacher/hsylcer',
    name: 'teacher-hsylcer',
    meta: {
      title: '电台'
    },
    component: () => import('../../views/student/Manager/Events/Hsylcer/Teacher')
  },
  {
    path: '/teacher/academic-resources',
    name: 'teacher-academic-resources',
    component: () => import('@/views/student/Manager/Academic/Teacher')
  },
  {
    path: '/teacher/house/rules',
    name: 'teacher-house-rules',
    meta: {
      title: 'House Cup Rules'
    },
    component: () => import('@/views/student/Manager/House/HouseCupRule/Teacher')
  },
  {
    path: '/teacher/hbr',
    name: 'teacher-hbr',
    component: () => import('@/views/student/Manager/Business/Teacher')
  },
  /**
   * @description Seminar 详情
   * @function /teacher/checkin
   * @param { Component } CourseDetail views/teacher/Attendance/List
   * @param { Name } pathname teacher-course-checkin
   */
  {
    path: '/teacher/checkin',
    name: 'teacher-course-checkin',
    meta: {
      title: '课程签到列表'
    },
    component: () => import('@/views/teacher/Attendance/List')
  },
  {
    path: '/teacher/openning',
    name: 'teacher-openning',
    meta: {
      title: '开幕式'
    },
    component: () => import('../../views/student/Manager/Events/Openning/Teacher')
  },
  {
    path: '/teacher/ending',
    name: 'teacher-ending',
    meta: {
      title: '闭幕式'
    },
    props: {
      ending: true
    },
    component: () => import('../../views/student/Manager/Events/Openning/Teacher')
  },
  /**
   * @description mc 详情
   * @function /teacher/mc-detail/:id
   * @param { Component } CourseDetail views/teacher/MC
   * @param { Name } pathname teacher-mc-detail
   */
  /**
   * @description 查看提交作业详情
   * @function /teacher/assignment-detail/:assignment_id
   * @param { Component } AssignmentDetail views/teacher/CourseManagement/Assignments
   * @param { Name } pathname teacher-assignment-detail
   */
  /**
   * @description 查看提交作业详情
   * @function /teacher/assignment-detail/participation
   * @param { Component } AssignmentDetail views/teacher/CourseManagement/Assignments/Participation
   * @param { Name } pathname teacher-assignment-participation
   */
  /**
   * @description 管理端首页
   * @function /admin
   * @param { Component } inde @/views/admin
   * @param { Name } pathname admin
   */
  {
    path: '/admin/:tab?',
    name: 'admin',
    meta: {
      title: 'admin'
    },
    redirect: to => ({
      name: 'dashboard',
      query: to.params.tab ? { tab: to.params.tab } : {}
    })
  },
  /**
   * @description 管理端首页-单课管理-作业详情
   * @function /admin/assignment-detail/:assignment_id
   * @param { Component } AssignmentDetail /views/admin/AssignmentDetail
   * @param { Name } pathname admin-course-assignment-detail
   */
  {
    path: '/admin/assignment-detail/:assignment_id',
    name: 'admin-course-assignment-detail',
    meta: {
      title: '作业详情'
    },
    component: () => import('@/views/admin/AssignmentDetail')
  },
  /**
   * @description 管理端 Capstone Report 提交详情
   * @function /admin/capstone-report/:course_id
   * @param { Component } CapstoneReportDetail /views/admin/CapstoneReportDetail
   * @param { Name } pathname admin-capstone-report-detail
   */
  {
    path: '/admin/capstone-report/:course_id',
    name: 'admin-capstone-report-detail',
    meta: {
      title: 'Capstone Report提交详情'
    },
    component: () => import('@/views/admin/CapstoneReportDetail')
  },
  /**
   * @description 管理端 Capstone Reflection 提交详情
   * @function /admin/capstone-reflection/:course_id
   * @param { Component } CapstoneReflectionDetail /views/admin/CapstoneReflectionDetail
   * @param { Name } pathname admin-capstone-reflection-detail
   */
  {
    path: '/admin/capstone-reflection/:course_id',
    name: 'admin-capstone-reflection-detail',
    meta: {
      title: 'Capstone Reflection提交详情'
    },
    component: () => import('@/views/admin/CapstoneReflectionDetail')
  },
  {
    path: '/teacher/house/rule',
    name: 'teacher-house-rule',
    meta: {
      title: '老师'
    },
    component: () => import('@/views/student/Manager/House/HouseCupRule')
  },
  /**
   * @description 老师端管理
   * @function /teacher
   * @param {Component} Info views/school/
   * @param {Name} pathname /school-student
   */
  {
    path: '/teacher/:filter',
    name: 'teacher-filter',
    meta: {
      title: '老师'
    },
    component: () => import('@/views/teacher/Legacy/Dashboard/Page')
  },
  /**
   * @description 十二学院抢地盘
   * @function /xii-siege 十二学院抢地盘
   * @param { Component } GrabFlag views/student/GrabFlag
   * @param { Name } pathname xii-siege
   */
  {
    path: '/xii-siege/teacher',
    name: 'xii-siege/teacher',
    meta: {
      name: 'hsylc 2021'
    },
    props: {
      teacher: true
    },
    component: () => import('@/views/student/GrabFlag')
  },
  /**
   * @description 分院测试游戏页面
   * @function /sorting-ceremony 分院测试游戏页面
   * @param { Component } Test views/student/SortingCeremony/Test
   * @param { Name } pathname sorting-ceremony
   */
  {
    path: '/sorting-ceremony/teacher',
    name: 'sorting-ceremony-teacher',
    meta: {
      title: 'HSYLC 2022 分院测试',
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('@/views/Activities/DigitalTeacher')
  },
  /**
   * @description 教师资料页面
   * @function /teacher-profile/:身份/:资料名称
   * @param { Component } Test views/teacher/Profile
   * @param { Name } pathname teacher-profile
   */
  {
    path: '/teacher-profile/:role/:profile',
    name: 'teacher-profile',
    meta: {
      title: '教师端资料'
    },
    component: () => import('@/views/teacher/Profile')
  }
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign(
    {},
    {
      role: ROLES.TEACHER,
      topBar: TOP_BARS.TEACHER
    },
    ret.meta
  );
  return ret;
});
export default routes;
